import React from 'react';
import { connect } from 'react-redux';
import { partial, map } from 'lodash';

import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';

import styles from './styles/index.scss';
import {
  approveConfirmAction,
  cancelConfirmAction,
  getConfirmations
} from 'modules/confirmation';
import { PropTypes } from 'helpers/react';

const { objectOf, shape, string, func } = PropTypes;
const dialogStyles = theme => ({
  paperWidthSm: {
    width: '75%',
    maxWidth: '768px'
  }
});

@connect(
  state => ({
    confirmations: getConfirmations(state)
  }),
  { approveConfirmAction, cancelConfirmAction }
)
class GlobalConfirmationDialogs extends React.Component {
  static propTypes = {
    confirmations: objectOf(
      shape({
        message: string.isRequired,
        confirmButtonLabel: string.isRequired,
        cancelButtonLabel: string.isRequired
      })
    ),
    approveConfirmAction: func,
    cancelConfirmAction: func,
    classes: shape({
      paperWidthSm: string
    }).isRequired
  };

  handleApprove = id => {
    this.props.approveConfirmAction(id);
  };

  handleCancel = id => {
    this.props.cancelConfirmAction(id);
  };

  render() {
    return (
      <div>
        {map(
          this.props.confirmations,
          ({ message, confirmButtonLabel, cancelButtonLabel }, id) =>
            <Dialog
              open
              key={id}
              classes={{
                paperWidthSm: this.props.classes.paperWidthSm
              }}
            >
              <DialogContent>
                {message}
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={partial(this.handleCancel, id)}
                  className={styles.dialogBtn}
                >
                  {cancelButtonLabel}
                </Button>
                <Button
                  onClick={partial(this.handleApprove, id)}
                  color="primary"
                  className={styles.dialogBtn}
                >
                  {confirmButtonLabel}
                </Button>
              </DialogActions>
            </Dialog>
        )}
      </div>
    );
  }
}

export default withStyles(dialogStyles)(GlobalConfirmationDialogs);



// WEBPACK FOOTER //
// ./src/client/shared-components/GlobalConfirmationDialogs/index.js